// extracted by mini-css-extract-plugin
export default {"container":"CareElementWithFrequencyLabel_container__KdWm-","careElementLabel":"CareElementWithFrequencyLabel_careElementLabel__nz9CC"};